import { render, staticRenderFns } from "./MetaSetEdit.vue?vue&type=template&id=28bd15b2&"
import script from "./MetaSetEdit.vue?vue&type=script&lang=js&"
export * from "./MetaSetEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports